// FIRE (Financial Independence, Retire Early) calculations.
// Kept separate from chartUtils since these operate on a target number
// and a growth rate rather than raw historical series.

/**
 * The net worth needed to sustain annualExpenses at withdrawalRate
 * (the "4% rule" is withdrawalRate = 0.04, i.e. expenses / 0.04 = expenses * 25).
 */
export const calculateFireNumber = (annualExpenses, withdrawalRate) => {
  const expenses = parseFloat(annualExpenses);
  const rate = parseFloat(withdrawalRate);
  if (!expenses || expenses <= 0 || !rate || rate <= 0) return null;
  return expenses / rate;
};

/**
 * Projects months-until-FI from the current net worth to the fire number,
 * reusing the same { type: 'rate' | 'delta', monthly } shape the
 * projection simulator already derives from historical data.
 *
 * Returns:
 *   null                    - not enough info to estimate (no fire number or no growth history)
 *   { reached: true }       - already at or past the fire number
 *   { reached: false, months: null } - flat/negative growth, will never get there at this rate
 *   { reached: false, months: N }    - months remaining at the current trajectory
 */
export const calculateTimeToFire = (currentNetWorth, fireNumber, growthInfo) => {
  if (fireNumber == null) return null;
  if (currentNetWorth >= fireNumber) return { reached: true };
  if (!growthInfo || growthInfo.monthly <= 0) return { reached: false, months: null };

  const months = growthInfo.type === 'rate'
    ? Math.log(fireNumber / currentNetWorth) / Math.log(1 + growthInfo.monthly)
    : (fireNumber - currentNetWorth) / growthInfo.monthly;

  if (!isFinite(months) || months < 0) return { reached: false, months: null };
  return { reached: false, months: Math.ceil(months) };
};
